import Vue from 'vue'
import { NetworkstatsState } from './networkstats.state'
import { NgcvpStats, UserNetworkStats } from '@/types/networkstats'
import store from '@/store'

export const mutations = {
  updateUserStats (state: NetworkstatsState, stats: UserNetworkStats) {
    Vue.set(state.userStats, stats.userId, stats)
    store.commit.status.updateNetworkStats(stats.userId)
  },
  updateNgcvpStats (state: NetworkstatsState, stats: NgcvpStats) {
    Vue.set(state.ngcvpStats, stats.castId, stats)
  }
} as const
